import React from 'react';
import Api from '../util/Api';

class VoucherCancel extends React.Component {
    constructor() {
        super();
        this.formBlockRef = React.createRef();
    }

    render() {
        return (
            <div className="container voucher-form voucher-success" ref={this.successBlockRef}>
                <i className="voucher-cancel__icon fas fa-times-circle"></i>
                <h1 className="voucher-success__title w-full text-center">
                    {trans.gift_voucher_order_cancel_title}
                </h1>
                <button className="btn btn-back" onClick={this.props.onBackClick}>
                    <span className="btn-text">{trans.continue_browsing}</span>
                </button>
            </div>
        )
    }
}


export default VoucherCancel;


// WEBPACK FOOTER //
// ./scripts/components/VoucherCancel.jsx